export default function isRequired(argument) {
	throw new Error(`The argument ${argument} is required`);
}
